<form [formGroup]="form" (ngSubmit)="onSubmit()" autocomplete="off">

    <nav class="toolbar navbar navbar-light">
        <div class="form-inline">
            <button class="btnback btn btn-outline-success" title="Volver" type="button" (click)="onBack()"><i class="fa fa-chevron-left"></i></button>
            <button *ngIf="!visibilitySpinner" type="submit" class="btn btn-outline-success" title="Guardar"><i class="fa fa-save"></i> Guardar</button>
            <button *ngIf="visibilitySpinner" [disabled]="true" class="btn btn-outline-success">
                <p-progressSpinner class="spinnerExcel"></p-progressSpinner>
                Guardando
            </button>
        </div>
    </nav>

    <div class="animated fadeIn container-fluid">
        <h4>{{editTitle}} País de Grupo Países FR</h4>
        <div class="row">
            <div class="col-md-12">

                <div class="card card-accent-success animated fadeIn">

                    <div class="card-header">
                    </div>

                    <div class="card-body-detalle">

                        <div class="group-filtros">

                            <div class="row">
                                <div class="form-group col-md-6">
                                    <label class="col-form-label required-field" for="inpPais">País</label>
                                    <ng-select [items]="listPais"
                                               bindLabel="Descripcion"
                                               bindValue="Id"
                                               formControlName="IdPais"
                                               loadingText="Cargando..."
                                               [readonly]="!listPais || listPais.length === 0"
                                               [loading]="!listPais || listPais.length === 0"
                                               notFoundText="País no encontrado"
                                               placeholder="-- Seleccione un País --"
                                               clearAllText="Eliminar selección"
                                               [ngClass]="displayFieldCssNgSelect('IdPais')">
                                    </ng-select>

                                    <div class="invalid-feedback d-block" *ngIf="isFieldInvalid('IdPais','required')">
                                        País es obligatorio
                                    </div>

                                    <div class="invalid-feedback d-block" *ngIf="isFieldInvalid('IdPais','pais_duplicated')">
                                        El País ya existe en el Grupo de Países FR
                                    </div>

                                </div>

                                <div class="form-group col-md-6">
                                    <label class="col-form-label required-field" for="intEstado">Grupo Países FR</label>
                                    <ng-select [items]="listGruposPaisesFr"
                                               bindLabel="Descripcion"
                                               bindValue="Id"
                                               formControlName="IdGrupoPaisFr"
                                               loadingText="Cargando..."
                                               [readonly]="!listGruposPaisesFr || listGruposPaisesFr.length === 0"
                                               [loading]="!listGruposPaisesFr || listGruposPaisesFr.length === 0"
                                               notFoundText="Grupo Países Fr no encontrado"
                                               placeholder="-- Seleccione un Grupo Países Fr --"
                                               clearAllText="Eliminar selección"
                                               [ngClass]="displayFieldCssNgSelect('IdGrupoPaisFr')">
                                        <ng-template ng-option-tmp let-item="item">
                                            <div container="body" ngbTooltip="{{item.Descripcion}}">{{item.Descripcion}}</div>
                                        </ng-template>
                                    </ng-select>

                                    <div class="invalid-feedback d-block" *ngIf="isFieldInvalid('IdGrupoPaisFr','required')">
                                        El Grupo de País FR es obligatorio
                                    </div>

                                </div>

                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

    </div>

</form>
